import { createAction, handleActions } from 'redux-actions';

const SET = 'hackleClient.SET';
const CLEAR = 'hackleClient.CLEAR';

const defaultState = {};

const setTemp = {
    variation : 'A', // 테스트 그룹 분배 타입
    variation_d : null, // 테스트 그룹 분배 타입 default
    resason : '', // 분배 결정 사유
    key : 0, // 실험 키
    channelCode : null,
    deviceType : null, 
    language : '',
    isShowHackle : false,
}

const setHackleClientAction = createAction( SET, payload => payload);
const clearHackleClientAction = createAction( CLEAR, payload => payload );

const hackleClient = handleActions({
    [ SET ] : ( state, action ) => {
        return {
            ...state,
            ...action.payload 
        }
    },
    [ CLEAR ] : ( state, action ) => {
       return {
         ...state,
         [action.payload]: { ...setTemp },
       };
    }

}, defaultState);

export default hackleClient;
export { setHackleClientAction, clearHackleClientAction }
